export default 'fonts/a339aeb377b9999a59c315959dc54aeb.woff2';